import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";
import "../../../styles/viewDetail.css";

function MatchTypeComponent(props) {
  const hasValue = props.matchType || props.fileName;
  return (
    <div className="vd-row">
      <span className="vd-label">
        Match filename{" "}
        <Tooltip title="The file name matched against the criteria selected in the dropdown">
          <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
        </Tooltip>
      </span>
      <span className={`vd-value${hasValue ? "" : " vd-value-empty"}`}>
        {hasValue
          ? [props.matchType, props.fileName].filter(Boolean).join(" · ")
          : "—"}
      </span>
    </div>
  );
}

export default MatchTypeComponent;
